import { render, staticRenderFns } from "./LayoutsFormDialog.vue?vue&type=template&id=6bea1efe&scoped=true"
import script from "./LayoutsFormDialog.vue?vue&type=script&lang=js"
export * from "./LayoutsFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea1efe",
  null
  
)

export default component.exports